module.exports = __webpack_public_path__ + "static/media/carbohydrates.69a3de68.png";